export const title = 'Proofing required';
export const pendingRequestTitle = 'Pending schedule requests';
export const pendingRequestSubTitle = 'Click to accept or decline request';
export const proofingSuccessMessage = 'You have successfully proofed your photos';
export const actionLabel = 'Your attention is needed';
export const proofingInfo = 'proofing allows you to view and purchase additional photos for your service before they go live';
export const scheduleRequestsInfo =
	'schedule requests are when a technician is interested in capturing your service but would like to change the date/time to fit their schedule';
